import {
    getMessages,
    getViewMessages,
    getMessagesTemplate,
    createmessages,
    editmessages,
    deletemessages,
} from "@/http/system/messageTemplate.js";

export default {
    namespaced: true,
    state: {
        ListMessages: [],
        ListViewMessages: [],
        ListViewMessagesTemplate: [],
        CreateMessagesTemplate: null,
    },
    actions: {
        async setMessages({ commit }) {
            try {
                const resp = await getMessages();
                commit("SET_MESSAGES", resp.data);
                return resp;
            } catch (error) {
                throw Error(
                    error.message.errors[0].defaultUserMessage ||
                    `Api failed with status code: ${error.message.httpStatusCode}`
                );
            }
        },
        async setViewMessages({ commit }, id) {
            try {
                const resp = await getViewMessages(id);
                commit("SET_VIEW_MESSAGES", resp.data);
                return resp;
            } catch (error) {
                throw Error(
                    error.message.errors[0].defaultUserMessage ||
                    `Api failed with status code: ${error.message.httpStatusCode}`
                );
            }
        },
        async setMessagesTemplate({ commit }) {
            try {
                const resp = await getMessagesTemplate();
                commit("SET_MESSAGES_TEMPLATE", resp.data);
                return resp;
            } catch (error) {
                throw Error(
                    error.message.errors[0].defaultUserMessage ||
                    `Api failed with status code: ${error.message.httpStatusCode}`
                );
            }
        },
        async createmessagesAction({ commit }, data) {
            try {
                const resp = await createmessages(data);
                commit("CREATE_MESSAGES_ACTION", resp.data.resourceId);
                return resp;
            } catch (error) {
                throw Error(
                    error.message.errors[0].defaultUserMessage ||
                    `Api failed with status code: ${error.message.httpStatusCode}`
                );
            }
        },
        async editmessagesAction({ commit }, data) {
            try {
                const resp = await editmessages(data.id, data.data);
                return resp;
            } catch (error) {
                throw Error(
                    error.message.errors[0].defaultUserMessage ||
                    `Api failed with status code: ${error.message.httpStatusCode}`
                );
            }
        },
        async deletemessagesAction({ commit }, data) {
            try {
                const resp = await deletemessages(data);
                return resp;
            } catch (error) {
                throw Error(
                    error.message.errors[0].defaultUserMessage ||
                    `Api failed with status code: ${error.message.httpStatusCode}`
                );
            }
        },

    },
    mutations: {
        SET_MESSAGES(state, payload) {
            Object.assign(state, { ListMessages: payload });
        },
        SET_VIEW_MESSAGES(state, payload) {
            Object.assign(state, { ListViewMessages: payload });
        },
        SET_MESSAGES_TEMPLATE(state, payload) {
            Object.assign(state, { ListViewMessagesTemplate: payload });
        },
        CREATE_MESSAGES_ACTION(state, payload) {
            Object.assign(state, { CreateMessagesTemplate: payload });
        },

    },
    getters: {
        getMessages(state) {
            return state.ListMessages;
        },

    },
};
